// The router mounts under /o/<slug>, so the browser's pathname carries a prefix the
// route table never sees. Strip it before reading the project, or every path check
// here misses by one segment.
const ORG_PREFIX = /^\/o\/[^/]+/;

export default function getProjectId(): string | undefined {
  return getProjectIdIfPresent() || undefined;
}

export function getProjectIdIfPresent(): string | undefined {
  const pathname = window.location.pathname.replace(ORG_PREFIX, '');

  if (!pathname.startsWith('/projects/')) {
    return undefined;
  }

  return pathname.split('/')[2];
}
